const ContainerPrimary = ({ children }) => {
  return (
    <>
      <div className=" bg-primary p-8 text-secondary">{children}</div>
    </>
  );
};

export default ContainerPrimary;
